import { frontendURL } from '../../../helper/URLHelper';
import PrayerRequestBoard from './prayer/PrayerRequestBoard.vue';
import DiscipleshipPipeline from './discipleship/DiscipleshipPipeline.vue';
import BotPersonaList from './bot/BotPersonaList.vue';
import BotPersonaEditPage from './bot/BotPersonaEditPage.vue';
import FlowsPage from './flows/FlowsPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ministry/prayer-requests'),
    name: 'prayer_request_board',
    meta: { permissions: ['administrator', 'agent'] },
    component: PrayerRequestBoard,
  },
  {
    path: frontendURL('accounts/:accountId/ministry/discipleship'),
    name: 'discipleship_pipeline',
    meta: { permissions: ['administrator', 'agent'] },
    component: DiscipleshipPipeline,
  },
  {
    path: frontendURL('accounts/:accountId/ministry/bot-personas'),
    name: 'bot_personas',
    meta: { permissions: ['administrator', 'agent'] },
    component: BotPersonaList,
  },
  {
    path: frontendURL('accounts/:accountId/ministry/bot-personas/new'),
    name: 'bot_personas_new',
    meta: { permissions: ['administrator', 'agent'] },
    component: BotPersonaEditPage,
  },
  {
    path: frontendURL(
      'accounts/:accountId/ministry/bot-personas/:personaId/edit'
    ),
    name: 'bot_personas_edit',
    meta: { permissions: ['administrator', 'agent'] },
    component: BotPersonaEditPage,
  },
  {
    path: frontendURL('accounts/:accountId/ministry/flows'),
    name: 'flows_index',
    meta: { permissions: ['administrator'] },
    component: FlowsPage,
  },
  {
    path: frontendURL('accounts/:accountId/ministry/flows/:flowId'),
    name: 'flows_edit',
    meta: { permissions: ['administrator'] },
    component: FlowsPage,
  },
];
